// export function getScenario(type, scenario, anno) {
//   return scenari[type][scenario][anno - 1];
// }

export function getScenarioAgg(bilancia, gesav, type, scenario, anno) {
  var data = null;
  if (bilancia) {
    data = scenari.bilanciaSi;
  } else {
    data = scenari.bilanciaNo;
  }
  if (gesav) {
    data = data.gesav;
  }
  return data[type][scenario][anno - 1];
}

export const scenari = {
  bilanciaNo: {
    gesav: {
      tutelaClima: {
        stressato: [
          0.03080000000000000000,
          0.02220000000000000000,
          0.02730000000000000000,
          0.02380000000000000000,
          0.00880000000000000000,
          -0.01020000000000000000,
          -0.01830000000000000000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
        ],
        sfavorevole: [
          0.03030000000000000000,
          0.03080000000000000000,
          0.02550000000000000000,
          0.02380000000000000000,
          0.03100000000000000000,
          0.02070000000000000000,
          0.02250000000000000000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
        ],
        moderato: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.03140000000000000000,
          0.03310000000000000000,
          0.03280000000000000000,
          0.03750000000000000000,
          0.03420000000000000000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
        ],
        favorevole: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.04290000000000000000,
          0.04330000000000000000,
          0.04450000000000000000,
          0.05430000000000000000,
          0.03950000000000000000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
        ]
      },

      pariOpportunita: {
        stressato: [
          0.03080000000000000000,
          0.02220000000000000000,
          0.02730000000000000000,
          0.02380000000000000000,
          0.00880000000000000000,
          -0.01020000000000000000,
          -0.01830000000000000000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
        ],
        sfavorevole: [
          0.03030000000000000000,
          0.03080000000000000000,
          0.02550000000000000000,
          0.02380000000000000000,
          0.03100000000000000000,
          0.02070000000000000000,
          0.02250000000000000000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
        ],
        moderato: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.03140000000000000000,
          0.03310000000000000000,
          0.03280000000000000000,
          0.03750000000000000000,
          0.03420000000000000000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
        ],
        favorevole: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.04290000000000000000,
          0.04330000000000000000,
          0.04450000000000000000,
          0.05430000000000000000,
          0.03950000000000000000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
        ]
      },

      consumoResponsabile: {
        stressato: [
          0.03080000000000000000,
          0.02220000000000000000,
          0.02730000000000000000,
          0.02380000000000000000,
          0.00880000000000000000,
          -0.01020000000000000000,
          -0.01830000000000000000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
        ],
        sfavorevole: [
          0.03030000000000000000,
          0.03080000000000000000,
          0.02550000000000000000,
          0.02380000000000000000,
          0.03100000000000000000,
          0.02070000000000000000,
          0.02250000000000000000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
        ],
        moderato: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.03140000000000000000,
          0.03310000000000000000,
          0.03280000000000000000,
          0.03750000000000000000,
          0.03420000000000000000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
        ],
        favorevole: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.04290000000000000000,
          0.04330000000000000000,
          0.04450000000000000000,
          0.05430000000000000000,
          0.03950000000000000000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
        ]
      },

      crescitaSostenibile: {
        stressato: [
          0.03080000000000000000,
          0.02220000000000000000,
          0.02730000000000000000,
          0.02380000000000000000,
          0.00880000000000000000,
          -0.01020000000000000000,
          -0.01830000000000000000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
        ],
        sfavorevole: [
          0.03030000000000000000,
          0.03080000000000000000,
          0.02550000000000000000,
          0.02380000000000000000,
          0.03100000000000000000,
          0.02070000000000000000,
          0.02250000000000000000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
        ],
        moderato: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.03140000000000000000,
          0.03310000000000000000,
          0.03280000000000000000,
          0.03750000000000000000,
          0.03420000000000000000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
        ],
        favorevole: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.04290000000000000000,
          0.04330000000000000000,
          0.04450000000000000000,
          0.05430000000000000000,
          0.03950000000000000000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
        ]
      },

      saluteBenessere: {
        stressato: [
          0.03080000000000000000,
          0.02220000000000000000,
          0.02730000000000000000,
          0.02380000000000000000,
          0.00880000000000000000,
          -0.01020000000000000000,
          -0.01830000000000000000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
          0.01189695188352720000,
        ],
        sfavorevole: [
          0.03030000000000000000,
          0.03080000000000000000,
          0.02550000000000000000,
          0.02380000000000000000,
          0.03100000000000000000,
          0.02070000000000000000,
          0.02250000000000000000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
          0.02636370354517360000,
        ],
        moderato: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.03140000000000000000,
          0.03310000000000000000,
          0.03280000000000000000,
          0.03750000000000000000,
          0.03420000000000000000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
          0.03299776424176470000,
        ],
        favorevole: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.04290000000000000000,
          0.04330000000000000000,
          0.04450000000000000000,
          0.05430000000000000000,
          0.03950000000000000000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
          0.04090112093568890000,
        ]
      }
    },

    // === COMPONENTI (bilancia NO) ===
    tutelaClima: {
      stressato: [
        -0.33488809028228700000,
        0.14826532243561100000,
        -0.06170036204006340000,
        -0.05317962726707460000,
        -0.04769431656817440000,
        -0.04377879620220850000,
        -0.04080116605551940000,
        -0.07201414204927310000,
        -0.07201414204927310000,
        -0.07201414204927310000,
        -0.07201414204927310000,
        -0.07201414204927310000,
        -0.07201414204927310000,
        -0.07201414204927310000,
        -0.07201414204927310000,
      ],
      sfavorevole: [
        -0.11531988889294900000,
        0.00919314672090144000,
        0.17437952594096600000,
        0.00515681743640317000,
        0.00000000000000000000,
        0.00000000000000000000,
        0.00000000000000000000,
        0.00752898749844055000,
        0.00752898749844055000,
        0.00752898749844055000,
        0.00752898749844055000,
        0.00752898749844055000,
        0.00752898749844055000,
        0.00752898749844055000,
        0.00752898749844055000,
      ],
      moderato: [
        0.06261656341061040000,
        0.06297966833561390000,
        0.06246504158285670000,
        0.06596170129683250000,
        0.07210327316970130000,
        0.07052390191119780000,
        0.04399016047636060000,
        0.06291410281477040000,
        0.06291410281477040000,
        0.06291410281477040000,
        0.06291410281477040000,
        0.06291410281477040000,
        0.06291410281477040000,
        0.06291410281477040000,
        0.06291410281477040000,
      ],
      favorevole: [
        0.30929098978225300000,
        0.03127171772824950000,
        0.07599482775649810000,
        0.00166905601168810000,
        0.08614480394009800000,
        0.01680535425238960000,
        0.12006122115442100000,
        0.08760953432465210000,
        0.08760953432465210000,
        0.08760953432465210000,
        0.08760953432465210000,
        0.08760953432465210000,
        0.08760953432465210000,
        0.08760953432465210000,
        0.08760953432465210000,
      ]
    },

    pariOpportunita: {
      stressato: [
        -0.33046800380719400000,
        0.13881900933486800000,
        -0.06204048181401860000,
        -0.05347820426060300000,
        -0.04796598751577840000,
        -0.04403118049545400000,
        -0.04103883753005160000,
        -0.07242661002496830000,
        -0.07242661002496830000,
        -0.07242661002496830000,
        -0.07242661002496830000,
        -0.07242661002496830000,
        -0.07242661002496830000,
        -0.07242661002496830000,
        -0.07242661002496830000,
      ],
      sfavorevole: [
        -0.09373609009914330000,
        0.06378497197617160000,
        0.06418696471168280000,
        0.02684669950419800000,
        0.00000000000000000000,
        0.00000000000000000000,
        0.00000000000000000000,
        0.00747239377621223000,
        0.00747239377621223000,
        0.00747239377621223000,
        0.00747239377621223000,
        0.00747239377621223000,
        0.00747239377621223000,
        0.00747239377621223000,
        0.00747239377621223000,
      ],
      moderato: [
        0.05753515038392250000,
        0.04725953761198620000,
        0.08052740554211320000,
        0.03471911743690500000,
        0.06104725504748740000,
        0.04970453260222500000,
        0.09042334400962230000,
        0.06002206362370300000,
        0.06002206362370300000,
        0.06002206362370300000,
        0.06002206362370300000,
        0.06002206362370300000,
        0.06002206362370300000,
        0.06002206362370300000,
        0.06002206362370300000,
      ],
      favorevole: [
        0.22788301454309400000,
        0.08199650612952760000,
        0.05067244626344780000,
        0.06790806698088340000,
        0.05003906960570780000,
        0.03249496570455990000,
        0.04773296513048410000,
        0.07814069392606850000,
        0.07814069392606850000,
        0.07814069392606850000,
        0.07814069392606850000,
        0.07814069392606850000,
        0.07814069392606850000,
        0.07814069392606850000,
        0.07814069392606850000,
      ]
    },

    consumoResponsabile: {
      stressato: [
        -0.31223733454735600000,
        0.11874476478002000000,
        -0.05995092723395580000,
        -0.05164369978174900000,
        -0.04629689690438040000,
        -0.04248075074503450000,
        -0.03957897169097120000,
        -0.07002037322405650000,
        -0.07002037322405650000,
        -0.07002037322405650000,
        -0.07002037322405650000,
        -0.07002037322405650000,
        -0.07002037322405650000,
        -0.07002037322405650000,
        -0.07002037322405650000,
      ],
      sfavorevole: [
        -0.10294694989302400000,
        0.02022814806440800000,
        0.11790331000140500000,
        0.00414886347249910000,
        0.00000000000000000000,
        0.00000000000000000000,
        0.00000000000000000000,
        0.00386189034886408000,
        0.00386189034886408000,
        0.00386189034886408000,
        0.00386189034886408000,
        0.00386189034886408000,
        0.00386189034886408000,
        0.00386189034886408000,
        0.00386189034886408000,
      ],
      moderato: [
        0.04165466550043910000,
        0.05489135009055570000,
        0.05455434186568890000,
        0.04215462025816370000,
        0.07204493227039150000,
        0.04260143694846420000,
        0.04403829274661340000,
        0.05022634270095040000,
        0.05022634270095040000,
        0.05022634270095040000,
        0.05022634270095040000,
        0.05022634270095040000,
        0.05022634270095040000,
        0.05022634270095040000,
        0.05022634270095040000,
      ],
      favorevole: [
        0.23295960155479100000,
        0.03027542125145310000,
        0.04025826792340650000,
        0.05722680067192170000,
        0.02519638056720170000,
        0.02787694185962100000,
        0.06167896721844190000,
        0.06587815412974350000,
        0.06587815412974350000,
        0.06587815412974350000,
        0.06587815412974350000,
        0.06587815412974350000,
        0.06587815412974350000,
        0.06587815412974350000,
        0.06587815412974350000,
      ]
    },

    crescitaSostenibile: {
      stressato: [
        -0.34737889390416300000,
        0.17635574081168500000,
        -0.06044443979182830000,
        -0.05207662129987380000,
        -0.04669057163035960000,
        -0.04284629231862260000,
        -0.03992305211099170000,
        -0.07060047934827430000,
        -0.07060047934827430000,
        -0.07060047934827430000,
        -0.07060047934827430000,
        -0.07060047934827430000,
        -0.07060047934827430000,
        -0.07060047934827430000,
        -0.07060047934827430000,
      ],
      sfavorevole: [
        -0.10133768152658500000,
        0.03469853625475780000,
        0.10498057505493400000,
        0.03918700663624140000,
        0.00000000000000000000,
        0.00000000000000000000,
        0.00000000000000000000,
        0.00940518474130458000,
        0.00940518474130458000,
        0.00940518474130458000,
        0.00940518474130458000,
        0.00940518474130458000,
        0.00940518474130458000,
        0.00940518474130458000,
        0.00940518474130458000,
      ],
      moderato: [
        0.06096394449393920000,
        0.04511629811744560000,
        0.05648727808264460000,
        0.06071148219685820000,
        0.06554839504370770000,
        0.05768975164114280000,
        0.07629237819750910000,
        0.06036529217835510000,
        0.06036529217835510000,
        0.06036529217835510000,
        0.06036529217835510000,
        0.06036529217835510000,
        0.06036529217835510000,
        0.06036529217835510000,
        0.06036529217835510000,
      ],
      favorevole: [
        0.26810874332544500000,
        0.05764113867622480000,
        0.02592050171175210000,
        0.06614181544383270000,
        0.04164432322306390000,
        0.04059866651863290000,
        0.06475832157732750000,
        0.07812268068900030000,
        0.07812268068900030000,
        0.07812268068900030000,
        0.07812268068900030000,
        0.07812268068900030000,
        0.07812268068900030000,
        0.07812268068900030000,
        0.07812268068900030000,
      ]
    },

    saluteBenessere: {
      stressato: [
        -0.31402402908606600000,
        0.11864643524334900000,
        -0.06057090097489860000,
        -0.05218772406845870000,
        -0.04679168789573730000,
        -0.04294023427245420000,
        -0.04001151338480990000,
        -0.07073379950261060000,
        -0.07073379950261060000,
        -0.07073379950261060000,
        -0.07073379950261060000,
        -0.07073379950261060000,
        -0.07073379950261060000,
        -0.07073379950261060000,
        -0.07073379950261060000,
      ],
      sfavorevole: [
        -0.12222252140461800000,
        0.03591866619907580000,
        0.12685706822285600000,
        0.00473809214688670000,
        0.00000000000000000000,
        0.00000000000000000000,
        0.00000000000000000000,
        0.00416375576564221000,
        0.00416375576564221000,
        0.00416375576564221000,
        0.00416375576564221000,
        0.00416375576564221000,
        0.00416375576564221000,
        0.00416375576564221000,
        0.00416375576564221000,
      ],
      moderato: [
        0.05407175784248410000,
        0.04225867193029240000,
        0.05238773478307750000,
        0.05267582141659770000,
        0.06235982696359830000,
        0.06067433789177760000,
        0.04543802433987730000,
        0.05281626958184080000,
        0.05281626958184080000,
        0.05281626958184080000,
        0.05281626958184080000,
        0.05281626958184080000,
        0.05281626958184080000,
        0.05281626958184080000,
        0.05281626958184080000,
      ],
      favorevole: [
        0.25607422246186100000,
        0.02073497173937990000,
        0.06601142960642830000,
        0.03614416509918470000,
        0.03406012110291410000,
        0.03294561533207770000,
        0.05607197211051940000,
        0.06920508446973270000,
        0.06920508446973270000,
        0.06920508446973270000,
        0.06920508446973270000,
        0.06920508446973270000,
        0.06920508446973270000,
        0.06920508446973270000,
        0.06920508446973270000,
      ],
    },
  },

  bilanciaSi: {
    gesav: {
      tutelaClima: {
        stressato: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.03140000000000000000,
          0.02359774432071260000,
          0.02677955141036490000,
          0.01279434580299550000,
          0.01347257023141470000,
          0.02426429589828860000,
          0.02426429589828860000,
          0.02426429589828860000,
          0.02426429589828860000,
          0.02426429589828860000,
          0.02426429589828860000,
          0.02426429589828860000,
          0.02426429589828860000,
        ],
        sfavorevole: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.03140000000000000000,
          0.03461591612408290000,
          0.03280776414000000000,
          0.03315046190000000000,
          0.02259470162941140000,
          0.03093202066562670000,
          0.03093202066562670000,
          0.03093202066562670000,
          0.03093202066562670000,
          0.03093202066562670000,
          0.03093202066562670000,
          0.03093202066562670000,
          0.03093202066562670000,
        ],
        moderato: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.03140000000000000000,
          0.04027776351677010000,
          0.03596201147575000000,
          0.03980264595860830000,
          0.03635073659706010000,
          0.03510650514339100000,
          0.03510650514339100000,
          0.03510650514339100000,
          0.03510650514339100000,
          0.03510650514339100000,
          0.03510650514339100000,
          0.03510650514339100000,
          0.03510650514339100000,
        ],
        favorevole: [
          0.02798788671734400000,
          0.03120000000000000000,
          0.03140000000000000000,
          0.02363961991441630000,
          0.03300087659804400000,
          0.04453646366964380000,
          0.03843214660048060000,
          0.03286588598472680000,
          0.03286588598472680000,
          0.03286588598472680000,
          0.03286588598472680000,
          0.03286588598472680000,
          0.03286588598472680000,
          0.03286588598472680000,
          0.03286588598472680000,
        ],
      },

      pariOpportunita: {
        stressato: [
          0.02785865161328570000,
          0.01452508110538430000,
          0.02674090003800710000,
          0.02111929690706000000,
          0.00592647086495957000,
          -0.02145548178156080000,
          -0.01867865940896190000,
          0.00782357707708692000,
          0.00782357707708692000,
          0.00782357707708692000,
          0.00782357707708692000,
          0.00782357707708692000,
          0.00782357707708692000,
          0.00782357707708692000,
          0.00782357707708692000,
        ],
        sfavorevole: [
          0.02675105085693560000,
          0.02094798817010560000,
          0.01764790463883870000,
          0.01415373259717240000,
          0.01535247482925530000,
          0.01167109050494490000,
          0.03311724924000000000,
          0.01992440746136540000,
          0.01992440746136540000,
          0.01992440746136540000,
          0.01992440746136540000,
          0.01992440746136540000,
          0.01992440746136540000,
          0.01992440746136540000,
          0.01992440746136540000,
        ],
        moderato: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.02682026163765130000,
          0.03310529609000000000,
          0.03280776414000000000,
          0.03046818418718370000,
          0.01855512293483770000,
          0.02909725921850130000,
          0.02909725921850130000,
          0.02909725921850130000,
          0.02909725921850130000,
          0.02909725921850130000,
          0.02909725921850130000,
          0.02909725921850130000,
          0.02909725921850130000,
        ],
        favorevole: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.03140000000000000000,
          0.03310529609000000000,
          0.04618190106381450000,
          0.05471594286933330000,
          0.07883587091699300000,
          0.04361669313987030000,
          0.04361669313987030000,
          0.04361669313987030000,
          0.04361669313987030000,
          0.04361669313987030000,
          0.04361669313987030000,
          0.04361669313987030000,
          0.04361669313987030000,
        ],
      },

      consumoResponsabile: {
        stressato: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.03140000000000000000,
          0.02363935139699860000,
          0.04211689271680200000,
          0.01347566036807580000,
          0.03349180874012980000,
          0.02941322784656550000,
          0.02941322784656550000,
          0.02941322784656550000,
          0.02941322784656550000,
          0.02941322784656550000,
          0.02941322784656550000,
          0.02941322784656550000,
          0.02941322784656550000,
        ],
        sfavorevole: [
          0.03080000000000000000,
          0.01996610456616170000,
          0.01300581811697300000,
          0.01626715456860660000,
          0.01514949447538030000,
          0.03178312800922870000,
          0.02257975006494240000,
          0.02134107646492420000,
          0.02134107646492420000,
          0.02134107646492420000,
          0.02134107646492420000,
          0.02134107646492420000,
          0.02134107646492420000,
          0.02134107646492420000,
          0.02134107646492420000,
        ],
        moderato: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.03140000000000000000,
          0.02363408826657700000,
          0.03280776414000000000,
          0.03535007672817640000,
          0.03311724924000000000,
          0.03118140423895690000,
          0.03118140423895690000,
          0.03118140423895690000,
          0.03118140423895690000,
          0.03118140423895690000,
          0.03118140423895690000,
          0.03118140423895690000,
          0.03118140423895690000,
        ],
        favorevole: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.03140000000000000000,
          0.03561920584430810000,
          0.03850532012444950000,
          0.05314878277627820000,
          0.05710432335673580000,
          0.03963315294217230000,
          0.03963315294217230000,
          0.03963315294217230000,
          0.03963315294217230000,
          0.03963315294217230000,
          0.03963315294217230000,
          0.03963315294217230000,
          0.03963315294217230000,
        ],
      },

      crescitaSostenibile: {
        stressato: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.02693128946712190000,
          0.01522631407343920000,
          0.01718053744147800000,
          0.00527542605511789000,
          0.00232577978416465000,
          0.01836142321108000000,
          0.01836142321108000000,
          0.01836142321108000000,
          0.01836142321108000000,
          0.01836142321108000000,
          0.01836142321108000000,
          0.01836142321108000000,
          0.01836142321108000000,
        ],
        sfavorevole: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.02779209967352540000,
          0.01839121824794850000,
          0.01951195924579130000,
          0.03315046190000000000,
          0.02806287598747450000,
          0.02697287504420780000,
          0.02697287504420780000,
          0.02697287504420780000,
          0.02697287504420780000,
          0.02697287504420780000,
          0.02697287504420780000,
          0.02697287504420780000,
          0.02697287504420780000,
        ],
        moderato: [
          0.03080000000000000000,
          0.04077425250312610000,
          0.03140000000000000000,
          0.03795883433678000000,
          0.03944521626464000000,
          0.05323965054041630000,
          0.04553202737090550000,
          0.03985324242216090000,
          0.03985324242216090000,
          0.03985324242216090000,
          0.03985324242216090000,
          0.03985324242216090000,
          0.03985324242216090000,
          0.03985324242216090000,
          0.03985324242216090000,
        ],
        favorevole: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.03140000000000000000,
          0.03628803816493580000,
          0.03280776414000000000,
          0.03315046190000000000,
          0.04809344292639810000,
          0.03480444491769790000,
          0.03480444491769790000,
          0.03480444491769790000,
          0.03480444491769790000,
          0.03480444491769790000,
          0.03480444491769790000,
          0.03480444491769790000,
          0.03480444491769790000,
        ],
      },

      saluteBenessere: {
        stressato: [
          0.02687585069665660000,
          0.02459949220340920000,
          0.02225788343237030000,
          0.01943774373229470000,
          0.00501642393249059000,
          -0.00118977274875648000,
          0.01604339252164080000,
          0.01610216927035400000,
          0.01610216927035400000,
          0.01610216927035400000,
          0.01610216927035400000,
          0.01610216927035400000,
          0.01610216927035400000,
          0.01610216927035400000,
          0.01610216927035400000,
        ],
        sfavorevole: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.03140000000000000000,
          0.02360854425010570000,
          0.01980068285348750000,
          0.03315046190000000000,
          0.01832427919545830000,
          0.02688183985443970000,
          0.02688183985443970000,
          0.02688183985443970000,
          0.02688183985443970000,
          0.02688183985443970000,
          0.02688183985443970000,
          0.02688183985443970000,
          0.02688183985443970000,
        ],
        moderato: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.03140000000000000000,
          0.03310529609000000000,
          0.03280776414000000000,
          0.03315046190000000000,
          0.03893958472710660000,
          0.03305441650515960000,
          0.03305441650515960000,
          0.03305441650515960000,
          0.03305441650515960000,
          0.03305441650515960000,
          0.03305441650515960000,
          0.03305441650515960000,
          0.03305441650515960000,
        ],
        favorevole: [
          0.03080000000000000000,
          0.03120000000000000000,
          0.03140000000000000000,
          0.03337923605724250000,
          0.04331498536493480000,
          0.03772130092962150000,
          0.04319335794458870000,
          0.03584559415406920000,
          0.03584559415406920000,
          0.03584559415406920000,
          0.03584559415406920000,
          0.03584559415406920000,
          0.03584559415406920000,
          0.03584559415406920000,
          0.03584559415406920000,
        ],
      },
    },

    tutelaClima: {
      stressato: [
        -0.06027592502451060000,
        0.05874335914510170000,
        0.04424596008128680000,
        -0.14850089447802100000,
        -0.20593269605980700000,
        0.02150525867122010000,
        -0.21784169497027500000,
        -0.07919592313095040000,
        -0.07919592313095040000,
        -0.07919592313095040000,
        -0.07919592313095040000,
        -0.07919592313095040000,
        -0.07919592313095040000,
        -0.07919592313095040000,
        -0.07919592313095040000,
      ],
      sfavorevole: [
        0.13573478794706600000,
        0.07907613939014780000,
        -0.00564361309489725000,
        0.07896735656340210000,
        0.03435300251684550000,
        0.01728787921985280000,
        -0.13040884202764400000,
        0.02676829730318490000,
        0.02676829730318490000,
        0.02676829730318490000,
        0.02676829730318490000,
        0.02676829730318490000,
        0.02676829730318490000,
        0.02676829730318490000,
        0.02676829730318490000,
      ],
      moderato: [
        0.02162985107099270000,
        0.11254331810999100000,
        0.03494989365643300000,
        0.12517749394331000000,
        0.06605572328017930000,
        0.01747677293380410000,
        -0.03825579614779120000,
        0.04716810893197040000,
        0.04716810893197040000,
        0.04716810893197040000,
        0.04716810893197040000,
        0.04716810893197040000,
        0.04716810893197040000,
        0.04716810893197040000,
        0.04716810893197040000,
      ],
      favorevole: [
        -0.05401272677330000000,
        0.12265695135244000000,
        0.12177006787518100000,
        0.02652110079077220000,
        0.16219395081652600000,
        0.15244953385224200000,
        0.01354332399951970000,
        0.07510173414034620000,
        0.07510173414034620000,
        0.07510173414034620000,
        0.07510173414034620000,
        0.07510173414034620000,
        0.07510173414034620000,
        0.07510173414034620000,
        0.07510173414034620000,
      ],
    },

    pariOpportunita: {
      stressato: [
        -0.06723312121856360000,
        0.04251632561304020000,
        -0.26381985599675900000,
        -0.07460301406444180000,
        -0.14432478576100500000,
        -0.07249546047018430000,
        0.21843755500637100000,
        -0.06163690471482970000,
        -0.06163690471482970000,
        -0.06163690471482970000,
        -0.06163690471482970000,
        -0.06163690471482970000,
        -0.06163690471482970000,
        -0.06163690471482970000,
        -0.06163690471482970000,
      ],
      sfavorevole: [
        -0.02918248848637720000,
        0.02519102881398360000,
        -0.02902663181688050000,
        0.03816717723211420000,
        -0.02487825309470910000,
        0.14703708668959600000,
        0.12529071236579900000,
        0.03388921919777290000,
        0.03388921919777290000,
        0.03388921919777290000,
        0.03388921919777290000,
        0.03388921919777290000,
        0.03388921919777290000,
        0.03388921919777290000,
        0.03388921919777290000,
      ],
      moderato: [
        0.11398347052088600000,
        0.04229617777375690000,
        0.07438525144735710000,
        0.14869817375126900000,
        0.06141176410039930000,
        -0.05181416976846460000,
        0.17519540425669800000,
        0.07828086999754920000,
        0.07828086999754920000,
        0.07828086999754920000,
        0.07828086999754920000,
        0.07828086999754920000,
        0.07828086999754920000,
        0.07828086999754920000,
        0.07828086999754920000,
      ],
      favorevole: [
        0.09734844329206330000,
        0.05924636843859620000,
        -0.02951754860391930000,
        0.12651664486335900000,
        0.16889355760561700000,
        0.10591771533841400000,
        0.23151581132431800000,
        0.10589767219403800000,
        0.10589767219403800000,
        0.10589767219403800000,
        0.10589767219403800000,
        0.10589767219403800000,
        0.10589767219403800000,
        0.10589767219403800000,
        0.10589767219403800000,
      ],
    },

    consumoResponsabile: {
      stressato: [
        -0.10698935021873500000,
        -0.06292599646773880000,
        -0.07506695483038730000,
        -0.18598429860991000000,
        0.01180879989139370000,
        -0.21730561663409100000,
        -0.01325980992786970000,
        -0.09627113024074940000,
        -0.09627113024074940000,
        -0.09627113024074940000,
        -0.09627113024074940000,
        -0.09627113024074940000,
        -0.09627113024074940000,
        -0.09627113024074940000,
        -0.09627113024074940000,
      ],
      sfavorevole: [
        -0.04783681362864740000,
        -0.05589896325459880000,
        0.00023472161306448100,
        0.06325616273624760000,
        0.01044202905125860000,
        0.12496824605863800000,
        -0.03198524176727960000,
        0.00726405100938465000,
        0.00726405100938465000,
        0.00726405100938465000,
        0.00726405100938465000,
        0.00726405100938465000,
        0.00726405100938465000,
        0.00726405100938465000,
        0.00726405100938465000,
      ],
      moderato: [
        -0.03120708517828670000,
        0.06507806506770560000,
        -0.03000522636573410000,
        0.12635047781123800000,
        -0.01571533126196260000,
        0.10615114789749700000,
        0.07958801083182230000,
        0.04103200983553030000,
        0.04103200983553030000,
        0.04103200983553030000,
        0.04103200983553030000,
        0.04103200983553030000,
        0.04103200983553030000,
        0.04103200983553030000,
        0.04103200983553030000,
      ],
      favorevole: [
        0.04373110499429940000,
        0.09351379011999360000,
        0.10051578996495100000,
        0.07552761588978530000,
        0.06327057569938340000,
        0.12210121545939100000,
        0.07086551402253380000,
        0.08109303867144550000,
        0.08109303867144550000,
        0.08109303867144550000,
        0.08109303867144550000,
        0.08109303867144550000,
        0.08109303867144550000,
        0.08109303867144550000,
        0.08109303867144550000,
      ],
    },

    crescitaSostenibile: {
      stressato: [
        0.09110362828153770000,
        -0.02911366028362240000,
        -0.12728942936921800000,
        -0.11231765888990200000,
        0.01444669268667260000,
        -0.10983125999742600000,
        -0.11701953716027100000,
        -0.05878716954422670000,
        -0.05878716954422670000,
        -0.05878716954422670000,
        -0.05878716954422670000,
        -0.05878716954422670000,
        -0.05878716954422670000,
        -0.05878716954422670000,
        -0.05878716954422670000,
      ],
      sfavorevole: [
        0.07997334952287780000,
        0.00604283173157816000,
        -0.01822782103909160000,
        -0.00945227441486374000,
        0.05778250427765830000,
        0.00993734732623719000,
        0.10499638854920400000,
        0.03207109544518530000,
        0.03207109544518530000,
        0.03207109544518530000,
        0.03207109544518530000,
        0.03207109544518530000,
        0.03207109544518530000,
        0.03207109544518530000,
        0.03207109544518530000,
      ],
      moderato: [
        0.16692852731746700000,
        0.10274034386444600000,
        0.00438519229451129000,
        -0.02197702443006210000,
        0.03262270504703910000,
        0.20600249527468300000,
        0.03985664456470950000,
        0.07294076649633240000,
        0.07294076649633240000,
        0.07294076649633240000,
        0.07294076649633240000,
        0.07294076649633240000,
        0.07294076649633240000,
        0.07294076649633240000,
        0.07294076649633240000,
      ],
      favorevole: [
        0.14010467741676900000,
        0.02534895166786670000,
        0.05740264337139970000,
        0.23871535997353200000,
        0.08954926013164230000,
        0.04675520180547110000,
        0.14834391114327900000,
        0.10451172139581600000,
        0.10451172139581600000,
        0.10451172139581600000,
        0.10451172139581600000,
        0.10451172139581600000,
        0.10451172139581600000,
        0.10451172139581600000,
        0.10451172139581600000,
      ],
    },

    saluteBenessere: {
      stressato: [
        -0.01972771305161740000,
        -0.00509940656076035000,
        -0.07543934860212290000,
        -0.13500966443012100000,
        -0.12533133526873300000,
        0.03817801770292540000,
        -0.12601023501390100000,
        -0.06622526921194160000,
        -0.06622526921194160000,
        -0.06622526921194160000,
        -0.06622526921194160000,
        -0.06622526921194160000,
        -0.06622526921194160000,
        -0.06622526921194160000,
        -0.06622526921194160000,
      ],
      sfavorevole: [
        0.12846162963783400000,
        0.06815121415934990000,
        0.01034786021635630000,
        -0.08008747598529250000,
        -0.03798406142018280000,
        0.14728413519934600000,
        -0.00396774761467311000,
        0.03020434808626260000,
        0.03020434808626260000,
        0.03020434808626260000,
        0.03020434808626260000,
        0.03020434808626260000,
        0.03020434808626260000,
        0.03020434808626260000,
        0.03020434808626260000,
      ],
      moderato: [
        0.06782936738040330000,
        0.00370102452900989000,
        0.06484954856954730000,
        0.04141278506398290000,
        -0.05065163276357400000,
        0.07907417963940680000,
        0.13991438921594500000,
        0.04794400015916620000,
        0.04794400015916620000,
        0.04794400015916620000,
        0.04794400015916620000,
        0.04794400015916620000,
        0.04794400015916620000,
        0.04794400015916620000,
        0.04794400015916620000,
      ],
      favorevole: [
        -0.06698064148989880000,
        0.16691075828602800000,
        0.13577968316894600000,
        0.01240945957656960000,
        0.09017390948761440000,
        0.08603326679123400000,
        0.09922257397696410000,
        0.07222557728512590000,
        0.07222557728512590000,
        0.07222557728512590000,
        0.07222557728512590000,
        0.07222557728512590000,
        0.07222557728512590000,
        0.07222557728512590000,
        0.07222557728512590000,
      ],
    },
  },
};
